export enum CheckOutSteps {
  Shipping = "shipping",
  Delivery = "delivery",
  Payment = "payment",
  FreeTrial = "free trial",
}

export enum FormFields {
  OrderAttributes = "orderAttributes",
  DeliveryOption = "deliveryOption",
}
